import React from 'react';
import { BrowserRouter, Routes, Route, Link, useNavigate, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import {About} from './pages/About';
import logo from './logo.svg';
import './App.css';
import axios from 'axios';
import { useState, useEffect } from 'react';

/*
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}
 */

//export default App;

function App() {
  const { isAuth, signIn } = useAuth();

  const tg = window.Telegram.WebApp;

  useEffect(() => {
    // Вызываем signIn при монтировании компонента,
    // передавая initData из Telegram WebApp API
    signIn(tg.initData);
  }, []);

  if(tg.initData !== "") {
    // Если пользователь аутентифицирован, показываем соответствующее сообщение
    if (isAuth) {
      return (
          <BrowserRouter>
            <nav>
              <Link to="/">Главная</Link> | <Link to="/about">О нас</Link>
            </nav>

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
            </Routes>
          </BrowserRouter>
      );
      //return <h1>Authenticated</h1>;
    }

    // Если не аутентифицирован, показываем другое сообщение
    return <h1>Not Authenticated</h1>;
  }
  else {
    return <h1>Error</h1>;
  }


}

export default App;

// Кастомный хук для аутентификации
const useAuth = () => {
  // Состояние, указывающее, авторизован ли пользователь
  const [isAuth, setIsAuth] = useState(false);

  // Функция для отправки данных на сервер и получения статуса аутентификации
  const signIn = async (initData: string) => {
    const { data } = await axios.post<boolean>(
        'https://tabbootattoobot.win/app/auth/signin', // URL эндпоинта аутентификации
        { initData }, // Передаем данные для входа
    );

    setIsAuth(data); // Устанавливаем статус аутентификации
  };

  return { isAuth, signIn };
};